var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 4H7.2C6.08 4 5.52 4 5.092 4.218C4.71565 4.40969 4.40969 4.71565 4.218 5.092C4 5.52 4 6.08 4 7.2V16.8C4 17.92 4 18.48 4.218 18.908C4.40974 19.2843 4.71569 19.5903 5.092 19.782C5.519 20 6.079 20 7.197 20H16.803C17.921 20 18.48 20 18.907 19.782C19.284 19.59 19.59 19.284 19.782 18.908C20 18.48 20 17.921 20 16.803V16.2M10 14H13",
    stroke: "#5B595C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3502 12.75L19.0502 9.44998M12.4502 6.69998C12.4502 7.20557 12.5498 7.7062 12.7433 8.17331C12.9367 8.64041 13.2203 9.06483 13.5778 9.42234C13.9353 9.77984 14.3598 10.0634 14.8269 10.2569C15.294 10.4504 15.7946 10.55 16.3002 10.55C16.8058 10.55 17.3064 10.4504 17.7735 10.2569C18.2406 10.0634 18.6651 9.77984 19.0226 9.42234C19.3801 9.06483 19.6637 8.64041 19.8571 8.17331C20.0506 7.7062 20.1502 7.20557 20.1502 6.69998C20.1502 6.19439 20.0506 5.69375 19.8571 5.22664C19.6637 4.75954 19.3801 4.33512 19.0226 3.97761C18.6651 3.62011 18.2406 3.33652 17.7735 3.14304C17.3064 2.94956 16.8058 2.84998 16.3002 2.84998C15.7946 2.84998 15.294 2.94956 14.8269 3.14304C14.3598 3.33652 13.9353 3.62011 13.5778 3.97761C13.2203 4.33512 12.9367 4.75954 12.7433 5.22664C12.5498 5.69375 12.4502 6.19439 12.4502 6.69998Z",
    stroke: "#5B595C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_1179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 13.2,
    fill: "white",
    transform: "translate(10.7998 1.19995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeeds);
export default __webpack_public_path__ + "static/media/needs.b9483df65f044761c48df74cf3e60be1.svg";
export { ForwardRef as ReactComponent };